<script setup lang="ts">
import Modal from './Modal.vue'
import Button from './Button.vue'
import { useI18n } from 'vue-i18n'

interface Props {
  modelValue: boolean
  title?: string
  message?: string
  confirmText?: string
  cancelText?: string
  variant?: 'primary' | 'danger'
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  loading: false,
})
void props

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  confirm: []
  cancel: []
}>()

const { t } = useI18n()

function confirm(): void {
  emit('confirm')
}

function cancel(): void {
  emit('update:modelValue', false)
  emit('cancel')
}
</script>

<template>
  <Modal
    :model-value="modelValue"
    :title="title ?? t('common.confirm')"
    size="sm"
    @update:model-value="(v) => emit('update:modelValue', v)"
  >
    <p class="text-sm text-fg-muted whitespace-pre-line">
      <slot>{{ message }}</slot>
    </p>
    <template #footer>
      <Button variant="ghost" size="sm" :disabled="loading" @click="cancel">
        {{ cancelText ?? t('common.cancel') }}
      </Button>
      <Button
        :variant="variant"
        size="sm"
        :loading="loading"
        @click="confirm"
      >
        {{ confirmText ?? t('common.confirm') }}
      </Button>
    </template>
  </Modal>
</template>
